import React from 'react'

const BackgroundTabContent = () => {
    return (
        <div style={{ marginLeft:"395px" }}>
            <h5>BackgroundTabContent</h5>
        </div>
    )
}

export default BackgroundTabContent
